import { WithResourceId } from '@mews-commander/types';
import { useResourcesCategoriesQuery } from './useResourcesCategoriesQuery';

export const useResourceName = ({ resourceId }: WithResourceId) => {
    const { data, isFetching } = useResourcesCategoriesQuery();

    return {
        resourceName: data?.resources?.[resourceId]?.name,
        isFetching,
    };
};
